import Cookies from 'js-cookie';
import type { ICurrentUser } from '@/service/user/types';

const TOKEN_KEY = 'token';
const USER_KEY = 'user';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function removeToken() {
  return localStorage.removeItem(TOKEN_KEY);
}

export function getUserInfo() {
  return (localStorage as any).getItem(USER_KEY)
}

export function removeUserInfo() {
  return localStorage.removeItem(USER_KEY);
}

export function setCookies(key: string, value: Parameters<typeof Cookies.set>[1]) {
  return Cookies.set(key, value);
}

export function getCookies(key: string) {
  return Cookies.get(key);
}

export function removeCookies(key: string) {
  return Cookies.remove(key);
}
export function getUser() {
  return Cookies.get(USER_KEY);
}
